export default state => state.trolley.loadingAdd;
